import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';

export interface TwitterCampaignModel {
  id: string;
  created_at: string;
  currency: string;
  daily_budget_amount_local_micro: number;
  deleted: boolean;
  start_time: string;
  end_time: string;
  entity_status: string;
  name: string;
  servable: boolean;
  standard_delivery: boolean;
}

export interface TwitterLineItemModel {
  campaign_id: string;
  entity_status: string;
  id: string;
  name: string;
  bid_type: string;
}

export class TwitterActionDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.TWITTERACTIONS, apiHelper);
  }

  public loadCampaigns(integrationId: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/campaigns?integrationId=' + integrationId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }

  public createAction(initials: any): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource();
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, initials, headers, null);
  }
}
